export default __webpack_public_path__ + "static/book-appointment-f55b45600616092f058a9108b95131d7.png";